(function () {
  'use strict';

  var KF_GUIDE_LINKS = [
    { match: function (n) { return /diamant|moissanite/i.test(n); }, url: 'https://maison-brillance.com/pages/notre-materiau-la-moissanite' }
  ];

  function findGuideLink(questionName) {
    for (var i = 0; i < KF_GUIDE_LINKS.length; i++) {
      if (KF_GUIDE_LINKS[i].match(questionName)) return KF_GUIDE_LINKS[i].url;
    }
    return null;
  }

  var guideContentCache = {};

  function openGuidePopup(url) {
    var popup = document.querySelector('[data-kf-guide-popup]');
    if (!popup) return;
    var iframe = popup.querySelector('[data-kf-guide-iframe]');
    var loading = popup.querySelector('[data-kf-guide-loading]');
    popup.hidden = false;
    iframe.hidden = true;
    loading.hidden = false;
    loading.innerHTML = 'Chargement…';

    var render = function (html) {
      iframe.srcdoc = html;
      iframe.hidden = false;
      loading.hidden = true;
    };

    if (guideContentCache[url]) { render(guideContentCache[url]); return; }

    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('#MainContent') || doc.querySelector('.page') || doc.querySelector('main');
      var inner = content ? content.outerHTML : doc.body.innerHTML;
      var styleLinks = Array.prototype.map.call(doc.querySelectorAll('link[rel="stylesheet"]'), function (l) {
        return '<link rel="stylesheet" href="' + l.getAttribute('href') + '">';
      }).join('\n');
      var wrapped = '<!doctype html><html><head><meta charset="utf-8">' +
        '<meta name="viewport" content="width=device-width, initial-scale=1">' +
        '<base href="' + url + '">' +
        styleLinks +
        '<style>body{margin:0;} [data-animate], [data-animate-child] { opacity: 1 !important; transform: none !important; }</style>' +
        '</head><body>' + inner + '</body></html>';
      guideContentCache[url] = wrapped;
      render(wrapped);
    }).catch(function () {
      loading.innerHTML = 'Impossible de charger la page. <a href="' + url + '" target="_blank" rel="noopener">Ouvrir dans un nouvel onglet</a>';
    });
  }

  function initGuidePopup() {
    var popup = document.querySelector('[data-kf-guide-popup]');
    if (!popup) return;
    document.body.appendChild(popup);
    popup.querySelectorAll('[data-kf-guide-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { popup.hidden = true; });
    });
  }

  function preloadImage(url) {
    return new Promise(function (resolve) {
      if (!url) { resolve(); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(); };
      img.onerror = function () { resolve(); };
      img.src = url;
    });
  }

  function money(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  function initConfigurator(root) {
    var specUrl = root.dataset.specUrl;
    var variants = [];
    try { variants = JSON.parse(root.dataset.variants || '[]'); } catch (e) { variants = []; }

    var spec = null;
    var config = {};
    var freeTextValues = {};
    var currentIndex = 0;
    var layerRenderToken = 0;

    var loadingOverlay = root.querySelector('[data-kf-loading]');
    var loadingBarFill = root.querySelector('[data-kf-loading-bar]');
    var loadingLabel = root.querySelector('[data-kf-loading-label]');
    var layerstack = root.querySelector('[data-kf-layerstack]');
    var progressEl = root.querySelector('[data-kf-progress]');
    var progressBarFillEl = root.querySelector('[data-kf-progress-bar-fill]');
    var priceEl = root.querySelector('[data-kf-price]');
    var almaAmountEl = root.querySelector('[data-kf-alma-amount]');
    var questionViewport = root.querySelector('[data-kf-question-viewport]');
    var prevBtn = root.querySelector('[data-kf-prev]');
    var nextBtn = root.querySelector('[data-kf-next]');
    var ctaEl = root.querySelector('[data-kf-cta]');
    var requiredHintEl = root.querySelector('[data-kf-required-hint]');

    function ruleMatches(rule) {
      return (rule.when || []).every(function (cond) {
        if (!cond.path || cond.path[0] !== 'questions') return false;
        var qid = cond.path[1];
        var current = config[qid];
        if (cond.assertion === 'is') return current === cond.value;
        return false;
      });
    }

    function activeThens() {
      var thens = [];
      (spec.rules || []).forEach(function (rule) {
        if (ruleMatches(rule)) thens = thens.concat(rule.then || []);
      });
      return thens;
    }

    function isQuestionDisabled(questionId) {
      return activeThens().some(function (t) {
        return t.type === 'DISABLE_QUESTION' && t.questionId === questionId;
      });
    }

    function restrictedAnswerId(questionId) {
      var found = activeThens().find(function (t) {
        return t.type === 'RESTRICT_ALL_BUT' && t.questionId === questionId;
      });
      return found ? found.answerId : null;
    }

    function visibleAnswers(q) {
      var restrict = restrictedAnswerId(q.id);
      if (!restrict) return q.answers;
      return q.answers.filter(function (a) { return a.id === restrict; });
    }

    function visibleQuestions() {
      return spec.questions.filter(function (q) { return !isQuestionDisabled(q.id); });
    }

    function priceFor(questionId, answerId) {
      if (!answerId) return 0;
      var byQ = spec.extraPrices[questionId];
      if (!byQ) return 0;
      var v = byQ[answerId];
      return v ? parseFloat(v) : 0;
    }

    function hasAnswer(q) {
      if (q.inputType === 'text') return !!(freeTextValues[q.id] && freeTextValues[q.id].trim());
      return !!config[q.id];
    }

    function computeTotal() {
      var total = spec.basePrice;
      spec.questions.forEach(function (q) {
        if (isQuestionDisabled(q.id)) return;
        total += priceFor(q.id, config[q.id]);
      });
      return total;
    }

    function findNearestVariant(total) {
      if (!variants.length) return null;
      var best = variants[0];
      var bestDiff = Math.abs(variants[0].price - total);
      variants.forEach(function (v) {
        var diff = Math.abs(v.price - total);
        if (diff < bestDiff) { best = v; bestDiff = diff; }
      });
      return best;
    }

    function enforceRestrictions() {
      spec.questions.forEach(function (q) {
        var restrict = restrictedAnswerId(q.id);
        if (restrict && config[q.id] !== restrict) config[q.id] = restrict;
      });
    }

    function resolveLayerUrl(part) {
      var answerId = config[part.questionId];
      if (!answerId) return null;
      return part.layerByAnswer[answerId] || null;
    }

    function renderLayers() {
      var token = ++layerRenderToken;
      var urls = spec.parts.map(resolveLayerUrl);
      Promise.all(urls.map(preloadImage)).then(function () {
        if (token !== layerRenderToken || !layerstack) return;
        layerstack.innerHTML = '';
        urls.forEach(function (url) {
          if (!url) return;
          var img = document.createElement('img');
          img.src = url;
          img.alt = '';
          layerstack.appendChild(img);
        });
      });
    }

    function renderImageQuestion(q) {
      var wrap = document.createElement('div');
      wrap.className = 'kf-answers';
      var answers = visibleAnswers(q).slice().sort(function (a, b) {
        return priceFor(q.id, a.id) - priceFor(q.id, b.id);
      });
      answers.forEach(function (a) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kf-answer' + (config[q.id] === a.id ? ' is-selected' : '');
        if (a.thumbnail) {
          var img = document.createElement('img');
          img.src = a.thumbnail;
          img.alt = a.name;
          btn.appendChild(img);
        } else {
          var ph = document.createElement('div');
          ph.className = 'kf-placeholder-sq';
          var span = document.createElement('span');
          span.textContent = a.name;
          ph.appendChild(span);
          btn.appendChild(ph);
        }
        var lbl = document.createElement('div');
        lbl.className = 'kf-lbl';
        lbl.textContent = a.name;
        btn.appendChild(lbl);
        var delta = priceFor(q.id, a.id);
        if (delta) {
          var d = document.createElement('div');
          d.className = 'kf-delta';
          d.textContent = '+' + money(delta);
          btn.appendChild(d);
        }
        btn.addEventListener('click', function () {
          config[q.id] = a.id;
          renderLayers();
          updatePrice();
          updateNextState();
          // Update selection state in place instead of rebuilding the answers
          // list, so the horizontal scroll position (mobile swipe row) is preserved.
          Array.prototype.forEach.call(wrap.querySelectorAll('.kf-answer'), function (c) {
            c.classList.toggle('is-selected', c === btn);
          });
        });
        wrap.appendChild(btn);
      });
      return wrap;
    }

    function renderDropdownQuestion(q) {
      var wrap = document.createElement('div');
      wrap.className = 'kf-select';
      var select = document.createElement('select');
      visibleAnswers(q).forEach(function (a) {
        var opt = document.createElement('option');
        opt.value = a.id;
        var delta = priceFor(q.id, a.id);
        opt.textContent = delta ? (a.name + ' (+' + money(delta) + ')') : a.name;
        if (config[q.id] === a.id) opt.selected = true;
        select.appendChild(opt);
      });
      select.addEventListener('change', function () {
        config[q.id] = select.value;
        renderLayers();
        renderCurrentQuestion();
        updatePrice();
      });
      wrap.appendChild(select);
      return wrap;
    }

    function renderTextQuestion(q) {
      var wrap = document.createElement('div');
      wrap.className = 'kf-text-input';
      var textarea = document.createElement('textarea');
      textarea.placeholder = q.placeholder || '';
      textarea.value = freeTextValues[q.id] || '';
      textarea.addEventListener('input', function () {
        freeTextValues[q.id] = textarea.value;
        updateNextState();
      });
      wrap.appendChild(textarea);
      return wrap;
    }

    function renderCurrentQuestion() {
      enforceRestrictions();
      var qs = visibleQuestions();
      if (currentIndex >= qs.length) currentIndex = qs.length - 1;
      if (currentIndex < 0) currentIndex = 0;
      var q = qs[currentIndex];
      if (!questionViewport || !q) return;
      questionViewport.innerHTML = '';
      var block = document.createElement('div');
      block.className = 'kf-question';
      var head = document.createElement('div');
      head.className = 'kf-question-head';
      var h3 = document.createElement('h3');
      h3.textContent = q.name;
      head.appendChild(h3);
      var guideUrl = findGuideLink(q.name);
      if (guideUrl) {
        var guideBtn = document.createElement('button');
        guideBtn.type = 'button';
        guideBtn.className = 'kf-guide-link';
        guideBtn.textContent = 'En savoir plus';
        guideBtn.addEventListener('click', function () { openGuidePopup(guideUrl); });
        head.appendChild(guideBtn);
      }
      block.appendChild(head);

      var field;
      if (q.inputType === 'text') field = renderTextQuestion(q);
      else if (q.inputType === 'dropdown') field = renderDropdownQuestion(q);
      else field = renderImageQuestion(q);
      block.appendChild(field);
      questionViewport.appendChild(block);

      if (progressEl) progressEl.textContent = 'Question ' + (currentIndex + 1) + ' / ' + qs.length;
      if (progressBarFillEl) progressBarFillEl.style.width = (((currentIndex + 1) / qs.length) * 100) + '%';
      if (prevBtn) prevBtn.disabled = currentIndex === 0;
      if (nextBtn) nextBtn.hidden = currentIndex === qs.length - 1;
      if (ctaEl) ctaEl.hidden = currentIndex !== qs.length - 1;
      updateNextState();
    }

    function updateNextState() {
      var qs = visibleQuestions();
      var q = qs[currentIndex];
      var ok = q ? hasAnswer(q) : true;
      if (nextBtn) nextBtn.disabled = !ok;
      updateCtaState();
      if (requiredHintEl) requiredHintEl.textContent = ok ? '' : 'Merci de répondre avant de continuer.';
    }

    function updateCtaState() {
      if (!ctaEl) return;
      var qs = visibleQuestions();
      var allAnswered = qs.every(hasAnswer);
      var total = computeTotal();
      var variant = findNearestVariant(total);
      ctaEl.disabled = !allAnswered || !variant;
      ctaEl.dataset.variantId = variant ? variant.id : '';
    }

    function updatePrice() {
      var total = computeTotal();
      if (priceEl) priceEl.textContent = money(total);
      if (almaAmountEl) almaAmountEl.textContent = money(total / 4);
      updateCtaState();
    }

    function buildLineItemProperties() {
      var props = {};
      spec.questions.forEach(function (q) {
        if (isQuestionDisabled(q.id)) return;
        if (q.inputType === 'text') {
          if (freeTextValues[q.id]) props[q.name] = freeTextValues[q.id];
        } else {
          var found = (q.answers || []).find(function (a) { return a.id === config[q.id]; });
          if (found) props[q.name] = found.name;
        }
      });
      return props;
    }

    function goPrev() {
      if (currentIndex > 0) { currentIndex--; renderCurrentQuestion(); }
    }
    function goNext() {
      var qs = visibleQuestions();
      var q = qs[currentIndex];
      if (q && !hasAnswer(q)) { updateNextState(); return; }
      if (currentIndex < qs.length - 1) { currentIndex++; renderCurrentQuestion(); }
    }

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        var variantId = ctaEl.dataset.variantId;
        if (!variantId) return;
        ctaEl.disabled = true;
        var properties = buildLineItemProperties();
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1, properties: properties }] })
        }).then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          // Close the configurator modal (instead of navigating to /cart) so the
          // theme's own cart drawer, opened by the cart:refresh event above, is visible.
          var modal = document.querySelector('[data-kf-modal]');
          if (modal) {
            modal.classList.remove('kf-modal--open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            setTimeout(function () { modal.setAttribute('hidden', ''); }, 250);
          }
          ctaEl.disabled = false;
        }).catch(function () {
          ctaEl.disabled = false;
        });
      });
    }

    fetch(specUrl).then(function (r) { return r.json(); }).then(function (json) {
      spec = json;
      config = Object.assign({}, spec.defaultConfiguration || {});

      var preloadUrls = [];
      spec.parts.forEach(function (p) {
        Object.keys(p.layerByAnswer || {}).forEach(function (aid) {
          if (config[p.questionId] === aid && p.layerByAnswer[aid]) preloadUrls.push(p.layerByAnswer[aid]);
        });
      });
      spec.questions.forEach(function (q) {
        (q.answers || []).forEach(function (a) { if (a.thumbnail) preloadUrls.push(a.thumbnail); });
      });

      var loaded = 0;
      var totalToLoad = preloadUrls.length || 1;
      Promise.all(preloadUrls.map(function (u) {
        return preloadImage(u).then(function () {
          loaded++;
          if (loadingBarFill) loadingBarFill.style.width = ((loaded / totalToLoad) * 100) + '%';
        });
      })).then(function () {
        renderLayers();
        renderCurrentQuestion();
        updatePrice();
        if (loadingOverlay) {
          loadingOverlay.classList.add('kf-loading-overlay--fading');
          setTimeout(function () { loadingOverlay.hidden = true; }, 300);
        }
      });
    }).catch(function () {
      if (loadingLabel) loadingLabel.textContent = "Impossible de charger le configurateur.";
    });
  }

  function lockBodyScroll() {
    var y = window.scrollY;
    document.body.dataset.kfScrollY = String(y);
    document.body.style.position = 'fixed';
    document.body.style.top = (-y) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
  }
  function unlockBodyScroll() {
    var y = parseInt(document.body.dataset.kfScrollY || '0', 10);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    window.scrollTo(0, y);
  }

  function initModals() {
    document.querySelectorAll('[data-kf-modal]').forEach(function (modal) {
      document.body.appendChild(modal);
      modal.addEventListener('touchmove', function (e) {
        if (e.target === modal || (e.target.classList && e.target.classList.contains('kf-modal-backdrop'))) {
          e.preventDefault();
        }
      }, { passive: false });
    });
    document.querySelectorAll('[data-kf-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = document.querySelector(btn.dataset.kfOpen ? '#' + btn.dataset.kfOpen : '[data-kf-modal]');
        if (!modal) return;
        modal.hidden = false;
        lockBodyScroll();
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { modal.classList.add('kf-modal--open'); });
        });
      });
    });
    document.querySelectorAll('[data-kf-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var modal = btn.closest('[data-kf-modal]');
        if (!modal) return;
        modal.classList.remove('kf-modal--open');
        unlockBodyScroll();
        setTimeout(function () { modal.hidden = true; }, 250);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-kf-configurator]').forEach(initConfigurator);
    initModals();
    initGuidePopup();
  });
})();

